import { render } from "./BudgetUpdate.vue?vue&type=template&id=12c453f9&scoped=true"
import script from "./BudgetUpdate.vue?vue&type=script&lang=js"
export * from "./BudgetUpdate.vue?vue&type=script&lang=js"

import "./BudgetUpdate.vue?vue&type=style&index=0&id=12c453f9&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c453f9"]])

export default __exports__